import { Gondor } from "../Gondor";

const ACTIONS = {
  LANDING_ITEM: "/landing/?code={landingId}&active=true&systemId={systemId}",
};

export function find(landingId: string,systemId: string) {
  return Gondor.http.get(ACTIONS.LANDING_ITEM.replace("{landingId}", landingId).replace("{systemId}",systemId));
}
